/**
 * 라우트 레이아웃 어휘 — `App.vue` 의 레이아웃 스위치·`router.beforeEach` 의 리다이렉트 게이트·`plugins/http` 의
 * 403 정책이 **같은 술어**를 읽는다 (POS 임베드 결정 브리프 2026-09-03 · D2). `App.vue` 가 `<router-view>` 에 주는
 * 키([routeViewKey])도 라우트 → 셸의 규칙이라 여기 있다.
 *
 * 의존성이 없는 모듈이다. http 플러그인은 라우터를 import 할 수 없고(라우터 → 뷰 → mixin → http 의 순환), 단위
 * 테스트(`npm run test:unit`)는 앱 번들 밖에서 이 파일을 그대로 읽는다.
 */
export const ROUTE_LAYOUT = Object.freeze({ DEFAULT: 'default', CLEAR: 'clear', EMBED: 'embed' })

/** 임베드 라우트의 주소 접두 — 라우트 등록(`/v/pos/*`)과 같은 사실이다 */
export const EMBED_PATH_PREFIX = '/v/pos/'

/** 라우트의 레이아웃 이름. meta 가 없으면 기본 레이아웃이다 */
export function routeLayoutOf(route) {
  const layout = route && route.meta && route.meta.layout
  return layout || ROUTE_LAYOUT.DEFAULT
}

/**
 * **POS 안에 띄우는 임베드 화면인가.**
 *
 * 임베드 라우트에는 앱 셸(AppBar·SideNav)·로그인 화면·주문 알림이 없다. 그래서 그 라우트에서는 **어디로도
 * 리다이렉트하지 않는다** — 권한 없음·미로그인·403 을 전부 페이지 안 안내로 답한다. 이 술어가 그 세 자리를
 * 함께 지킨다.
 */
/**
 * 주소만 보고 임베드인가 — **라우트가 아직 없을 때** 쓴다 (2026-09-03 리뷰 지적).
 *
 * 최초 내비게이션이 실패하면 `$route` 는 START(`/`)라 `meta` 가 비어 있다. 그 상태로 붙이면 임베드 창에
 * 관리자 셸이 그려져 주문 알림음·동의창·웹소켓이 POS 안에서 켜진다 — 임베드가 없애려던 바로 그것이다.
 */
export function isEmbedPath(pathname) {
  return String(pathname || '').startsWith(EMBED_PATH_PREFIX)
}

export function isEmbedRoute(route) {
  return routeLayoutOf(route) === ROUTE_LAYOUT.EMBED
}

/**
 * **`<router-view>` 의 키 — 라우트 레코드 하나가 화면 인스턴스 하나다.**
 *
 * vue-router 3 은 **같은 컴포넌트를 쓰는 두 라우트** 사이를 옮길 때 인스턴스를 재사용한다 — `data()`·`created()` 가
 * 다시 돌지 않아, 라우트가 prop 으로 준 설정(할인 관리의 세션 매장 ↔ 고른 매장 원천)으로 선 상태·경로·나가 있는
 * 조회가 앞 라우트의 것으로 남는다. 키를 **라우트 레코드**(등록된 경로 패턴 `matched[0].path`, 라우트는 전부 flat)로
 * 두면 그 이동만 새 인스턴스가 되고, 같은 레코드 안의 질의·파라미터 변화는 종전대로 재사용된다(질의를 워처로 받는
 * 화면 — 운영사·관리점의 `?includeInactive=` 등). 서로 다른 컴포넌트 사이의 이동은 원래 새 인스턴스라 뜻이 같다.
 *
 * 아직 맞는 레코드가 없으면(START·등록 안 된 주소) 주소 자체다.
 */
export function routeViewKey(route) {
  const record = route && route.matched && route.matched[0]

  return record ? record.path : (route && route.path) || ''
}
